import React, {useState} from 'react';
import styled from "styled-components";
import IconBtn from "../Icn";


const DragAreaStyled = styled.div`
  position: absolute;
  left: -50px;
  right: -50px;
  top: -50px;
  bottom: -50px;
  z-index: 599;
`;

const WrapperStyled = styled.div`
  position: absolute;
  left: 50px;
  right: 50px;
  top: 50px;
  bottom: 50px;
  z-index: 600;
  text-align: center;

  svg {
    width: 15px;
    height: 15px;
  }

  & > div {
    position: absolute;
    width: 100%;
    height: 25%;
    transition: background 200ms linear;

    &:hover {
      background: #1f8c6f4d;
      transition: background 300ms linear;
    }
  }

  .top {
    top: 0;

    svg {
      transform: rotate(270deg);
    }
  }

  .right {
    right: 0;
    width: 20%;
    height: 100%;
    display: grid;
    align-items: center;
  }

  .bottom {
    bottom: 0;

    svg {
      transform: rotate(90deg);
      top: -3px;
      position: relative;
    }
  }

  .left {
    left: 0;

    width: 20%;
    height: 100%;

    display: grid;
    align-items: center;

    svg {
      margin-left: 2px;
      transform: rotate(180deg);
    }
  }
`;

const MiniResizer = ({onPositionChangeHandle}) => {
    const [isDragging, s_isDragging] = useState(false);
    const [draggingType, s_draggingType] = useState(null);
    const [currentValue, s_currentValue] = useState(null);

    const onPositionChange = (pos, isInc) => {
        onPositionChangeHandle(pos, isInc);
    };

    return (
        <DragAreaStyled
            onMouseMove={(e) => {
                e.stopPropagation();
                if (isDragging) {
                    const x = e.clientX;
                    const y = e.clientY;
                    let valToOperate = null;
                    if (draggingType === 'top') {
                        valToOperate = y;
                    }
                    if (draggingType === 'right') {
                        valToOperate = x;
                    }
                    if (draggingType === 'bottom') {
                        valToOperate = y;
                    }
                    if (draggingType === 'left') {
                        valToOperate = x;
                    }

                    if (currentValue) {
                        if(draggingType === 'right' || draggingType === 'bottom') {
                            if (valToOperate > currentValue) {
                                onPositionChange(draggingType, true);
                            } else if (valToOperate < currentValue) {
                                onPositionChange(draggingType, false);
                            }
                        }else{
                            if (valToOperate < currentValue) {
                                onPositionChange(draggingType, true);
                            } else if (valToOperate > currentValue) {
                                onPositionChange(draggingType, false);
                            }
                        }
                    }
                    s_currentValue(valToOperate);
                }
            }}
            onMouseUp={(e) => {
                e.stopPropagation();
                s_isDragging(false);
                s_draggingType(null);
            }}
        >
            <WrapperStyled>
                <div
                    onMouseDown={(e) => {
                        e.stopPropagation();
                        s_isDragging(true);
                        s_draggingType('top');
                    }}
                    className="top">
                    <IconBtn>doubleArrowIcon</IconBtn>
                </div>
                <div
                    onMouseDown={(e) => {
                        e.stopPropagation();
                        s_isDragging(true);
                        s_draggingType('right');
                    }}
                    className="right">
                    <IconBtn>doubleArrowIcon</IconBtn>
                </div>
                <div
                    onMouseDown={(e) => {
                        e.stopPropagation();
                        s_isDragging(true);
                        s_draggingType('bottom');
                    }}
                    className="bottom">
                    <IconBtn>doubleArrowIcon</IconBtn>
                </div>
                <div
                    onMouseDown={(e) => {
                        e.stopPropagation();
                        s_isDragging(true);
                        s_draggingType('left');
                    }}
                    className="left">
                    <IconBtn>doubleArrowIcon</IconBtn>
                </div>
            </WrapperStyled>
        </DragAreaStyled>
    );
};

export default MiniResizer;